<template>
    <div class="container">
        <PatientsListingFilters 
            :filters="params"
            :order-options="orderOptions"
            @change="onFilters" 
        />

        <div class="matrix-panel">
            <div class="table-clinician table-layout table-patient">
                <TableHeader v-if="patients.length !== 0" :showDaysTillEndOfSubscription="showDaysTillEndOfSubscription" />

                <PatientsListingTableBody
                    ref="TableBody"
                    :phase="phase"
                    :freemium="freemium"
                    :params="params"
                    :freeze="freeze"
                    :deactivated="deactivated"
                    @fetched="onFetched"
                >
                    <PatientRow v-for="patient in patients" :key="patient.id" :class="{'patient-inactive': freeze || deactivated}" :patient="patient" :showDaysTillEndOfSubscription="showDaysTillEndOfSubscription" />
                </PatientsListingTableBody>
            </div>
        </div>

        <CoachDetailModal />
    </div>
</template>

<script>
import TableHeader from '@components/Doctors/PatientsMatrix/Intensive/TableHeader'
import PatientRow from '@components/Doctors/PatientsMatrix/Intensive/PatientRow'
import CoachDetailModal from '@components/Doctors/PatientsMatrix/CoachDetailModal'
import PatientsListing from '@components/PatientsMatrix/PatientsMatrix'

export default {
    components: {
        TableHeader,
        PatientRow,
        CoachDetailModal
    },
    extends: PatientsListing,
    props: {
        orderOptions: {
            type: Array,
            required: false,
            default() {
                return ['newest','oldest']
            }
        },
    },
    mounted() {
        $(function() {
            $('.item-patient').addClass('active')
        })
    },
}
</script>
